/**
 * Shared helpers for rendering product/promotion subtitles and labels on the
 * customer-facing widgets. Subtitles may arrive either as an array of strings
 * (the GraphQL entity resolver returns [String]) or as an array of row objects
 * ({ text }) from the server-side render/sync path, so normalise both here.
 */

export function subtitleLines(item){

    const subtitles = item && item.subtitles;

    if(subtitles && subtitles.length){
        return subtitles.map(subtitle => (typeof subtitle === 'string' ? subtitle : subtitle.text));
    }

    // Fall back to the legacy scalar column when no rows are present.
    return item && item.subtitle ? [item.subtitle] : [];
}

/**
 * Background style for a label badge. The colour comes from the label's own
 * catalogue colour; when the widget's "show background" toggle is off the badge
 * is drawn without a fill (text/icon only).
 */
export function labelBackgroundStyle(label, showBackground){

    if(showBackground === false){
        return { backgroundColor: 'transparent' };
    }

    const raw = (label && label.color) || '888888';
    const hex = raw.charAt(0) === '#' ? raw : ('#' + raw);

    return { backgroundColor: hex };
}
